import { UF } from '@usucampeao/interfaces';
import { Expose, Type } from 'class-transformer';
import { IsDate, IsEnum, IsNotEmpty, IsString } from 'class-validator';

export class RgDto {
  @Expose()
  @IsString()
  @IsNotEmpty()
  number: string;

  @Expose()
  @IsString()
  @IsNotEmpty()
  issuer: string;

  @Expose()
  @IsEnum(UF)
  @IsNotEmpty()
  state: UF;

  @Expose()
  @Type(() => Date)
  @IsDate()
  @IsNotEmpty()
  issueDate: Date;
}
